<template>
  <transition
      appear
      mode="out-in"
      v-bind:css="false"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:leave="actions.leaveProduct"
    >
    <span>
      <div class="mid-holder">
        <div class="product-five-bg product-bg-global"></div>
        
          <div ref="productImg" class="product-img"  style="text-align: center;" >  <img :src="require('@/assets/imgs/product-img-five.png')" /></div>
        <!-- </transition> -->
      </div>
      <Background></Background>
      <div class="bottom-holder position-relative">
        <div >
          <div class="product-copy-container" ref="productCopy">
            <div class="product-title" v-html="$t('slide_five.title')"></div>
            <div
              class="product-description"
              v-html="$t('slide_five.content')"
            ></div>
          </div>
        </div>
        
      </div>
    </span>
  </transition>
 
</template>

<script>
import { inject } from "vue";
import gsap from 'gsap';

import Background from "@/views/Background.vue";

export default {
  name: "Slidefive",
  components: {
    Background
  },
  props: {
    transitionIn: {
      type: Boolean,
      default: false
    },
    transitionOut: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const store = inject("store");
    return {
      state: store.state,
      actions: store.actions,
    };

  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 0);
  },
  watch: {
    transitionIn: function(newVal, oldVal) {
      console.log('watch transitionIn', newVal, oldVal);

      if( newVal === true && oldVal === false ) {
        // do something if you need to use the transitionIn prop from the parent
      }
    },
    transitionOut: function(newVal, oldVal) {
      console.log('watch transitionOut', newVal, oldVal);

      if( newVal === true && oldVal === false ) {
        this.leave();
      }
    },
  },
  beforeUnmount() {
    console.log('beforeUnmount');

    // this.show = false;
    // this.leave()
    gsap.to([this.$refs.productImg, this.$refs.productCopy], 0.5, {opacity: 0});
  },
  methods:{
    beforeEnter(el) {
      console.log('Slidefive beforeEnter()', el);
      // console.log(this.$refs.productImg);
      
    },
    enter(el, done) {
      console.log('Slidefive enter()', el);

      // console.log('productImg:', this.$refs.productImg);
      // console.log('productCopy:', this.$refs.productCopy);

      gsap.set(this.$refs.productImg, {opacity: 0}).delay(0);
      gsap.set(this.$refs.productCopy, {opacity: 0}).delay(0);

      gsap.to(this.$refs.productImg, 0.6, {opacity: 1});
      gsap.to(this.$refs.productCopy, 0.6, {opacity: 1, onComplete: done}).delay(0.5);

      // done();
    },
    leave(el, done) {
      console.log('Sliderfive leave()', el);

      gsap.to(
        [this.$refs.productImg, this.$refs.productCopy], 
        0.4, 
        {
          opacity: 0, 
          delay:0.5,
          onComplete: () => { 
            if( done ) done(); 
          }
        }
      );
    },
  }
};
</script>

<style scoped>

.product-five-bg {
  background: url("../assets/imgs/product-bg-five.jpg") center no-repeat;
}
</style>
